import {KinesisEvent} from "../kinesis.event";
import {KINESIS} from "../../kinesis.consts";

export class WizardDoneClickKinesisEvent extends KinesisEvent {
  constructor() {
    super(
      KINESIS.CATEGORY.bolao,
      KINESIS.ACTION.wizard,
      KINESIS.LABEL.done,
      KINESIS.VALUE.click,
    );
  }
}
